import * as yup from 'yup'

export default yup.object().shape({
  name: yup.string().required('Required field'),
  debouncePeriodInSeconds: yup.number().required('Required field'),
})
